// The % number is rendered by Liquid and never changed here, so SEO / LLM crawlers read the real value.
// Only the ring fill sweeps in.
if (!customElements.get('percentage-ring')) {
  customElements.define(
    'percentage-ring',
    class PercentageRing extends HTMLElement {
      constructor() {
        super();
        this.percentage = parseInt(this.dataset.percentage || 0, 10);
        this.duration = 1200;
        this.hasAnimated = false;
      }

      connectedCallback() {
        this.fillEl = this.querySelector('.percentage-ring__fill');
        if (!this.fillEl || this.percentage <= 0) return;

        this.style.setProperty('--percent', '0');

        if (window.FoxTheme?.Motion) {
          window.FoxTheme.Motion.inView(this, this.animate.bind(this), { margin: '0px 0px -50px 0px' });
        } else {
          this.animate();
        }
      }

      animate() {
        if (this.hasAnimated) return;
        this.hasAnimated = true;

        if (window.FoxTheme?.Motion?.animate && !window.FoxTheme.config?.motionReduced) {
          const startTime = performance.now();
          const easeOutQuart = (t) => 1 - Math.pow(1 - t, 4);

          const step = (now) => {
            const progress = Math.min((now - startTime) / this.duration, 1);
            this.style.setProperty('--percent', String(Math.round(easeOutQuart(progress) * this.percentage)));
            if (progress < 1) {
              requestAnimationFrame(step);
            } else {
              this.style.setProperty('--percent', String(this.percentage));
            }
          };
          requestAnimationFrame(step);
        } else {
          this.style.setProperty('--percent', String(this.percentage));
        }
      }
    }
  );
}
